import React from 'react';
import Wrapper from 'ui/Wrapper';
import QuickPickCard from 'features/QuickPickCard';
import { PRODUCT_IDS } from 'configs/products';
import Spinner from 'ui/Spinner';
import { connect } from 'react-redux';
import { fetchServerTime } from 'features/AISDataProvider/actions';

class OverviewQuickPick extends React.Component {
    componentDidMount() {
        this.getData();
    }

    // pool list data is fetched in AISDataProvider
    getData = () => {
        const { fetchServerTime } = this.props;

        fetchServerTime();
    };

    render() {
        const { poolList } = this.props;

        let sortedData =
            poolList.length > 0
                ? poolList.sort((a, b) => (a.date >= b.date ? 1 : -1))
                : null;

        if (sortedData) {
            sortedData = sortedData.sort((a, b) => (b.danish ? 1 : -1));

            sortedData = sortedData.sort(
                (a, b) =>
                    b.product.id === PRODUCT_IDS.V75 ||
                    b.product.id === PRODUCT_IDS.V86
                        ? 1
                        : -1
            );
        }

        return (
            <Wrapper>
                {sortedData ? (
                    <Wrapper padding="0px">
                        {sortedData
                            .slice(0, this.props.size || 3)
                            .map((item, index) => (
                                <QuickPickCard
                                    small={3}
                                    key={index}
                                    item={item}
                                />
                            ))}
                        <div style={{ clear: 'both' }} />
                    </Wrapper>
                ) : (
                    <Spinner size="x3" secondary />
                )}
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    poolList: state.AISDataProvider.poolList,
    serverTime: state.AISDataProvider.serverTime,
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchServerTime: () => {
            dispatch(fetchServerTime());
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OverviewQuickPick);
